// import React, { createContext, useContext } from 'react';
import api from 'utils/api';
import { useQuery } from 'react-query';

/**
 * @param {string} organizationId
 */
export function useReferralSettings(organizationId) {
  const queryKey = `referral-settings--${organizationId}`;
  return useQuery(queryKey, () =>
    api
      .get(
        `/agent_portal/api/referral_settings?organization_id=${
          organizationId || ''
        }`
      )
      .then((resp) => resp.data)
  );
}
